module.exports = __webpack_public_path__ + "static/media/Vector-6.eb540c16.svg";